import { render, staticRenderFns } from "./SearchArchive.vue?vue&type=template&id=5d27a4f2&scoped=true&"
import script from "./SearchArchive.vue?vue&type=script&lang=js&"
export * from "./SearchArchive.vue?vue&type=script&lang=js&"
import style0 from "./SearchArchive.vue?vue&type=style&index=0&id=5d27a4f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d27a4f2",
  null
  
)

export default component.exports